import React from 'react';
import { createBrowserHistory } from 'history';
import Logger from '../toolkit/logger/Logger';
import Login from '../components/auth/Login';
import Users from '../components/user/Users';
import Home from '../components/dashboard/Home';
import Logout from '../components/common/Logout';
import Devices from '../components/device/Devices';
import EditUser from '../components/user/EditUser';
import GraphPage from '../components/device/GraphPage';
import CreateUser from '../components/user/CreateUser';
import EditDevice from '../components/device/EditDevice';
import ForgetPassword from '../components/auth/ForgetPassword';
import UnknownDevices from '../components/device/UnknownDevices';
import ResetPassword from '../components/auth/ResetPassword';
import CreateDevice from '../components/device/CreateDevice';
import ProtectedRoute from '../components/common/ProtectedRoute';
import Collection from '../components/collection/Collection';
import { Router, Route, Switch, Redirect } from 'react-router';

const history = createBrowserHistory();

const renderLoginPage = () => {
  const token = localStorage.getItem('token');
  Logger.log('AppRouter::renderLoginPage::getToken =>', token);
  if (token) {
    return <Redirect to="/dashboard" />
  }
  return <Redirect to="/login" />
};


const AppRouter = () => {
  return (
    <Router history={history}>
      <Switch>
        <Route path="/" component={renderLoginPage} exact />
        <Route path="/login" component={Login} exact />
        <Route path="/forget-password" component={ForgetPassword} exact />
        <Route path="/reset-password" component={ResetPassword} exact />
        <Route path="/logout" component={Logout} exact />
        <ProtectedRoute path="/dashboard" component={Home} exact />
        <ProtectedRoute path="/dashboard/users" component={Users} exact />
        <ProtectedRoute path="/dashboard/create-user" component={CreateUser} exact />
        <ProtectedRoute path="/dashboard/edit-user/:userId" component={EditUser} exact />
        <ProtectedRoute path="/dashboard/devices" component={Devices} exact />
        <ProtectedRoute path="/dashboard/unknown-devices" component={UnknownDevices} exact />
        <ProtectedRoute path="/dashboard/graph/:device" component={GraphPage} exact />
        <ProtectedRoute path="/dashboard/create-device" component={CreateDevice} exact />
        <ProtectedRoute path="/dashboard/devices/edit/:device" component={EditDevice} exact />
        <ProtectedRoute path="/dashboard/collections" component={Collection} exact />
      </Switch>
    </Router>
  );
};

export { history };

export default AppRouter;
